<template>
    <AppSection :title="params.title" :class="['section-help', params.bg]">
        <template #header_left v-if="params.header_left">
            <div v-html="params.header_left"></div>
        </template>
        <template #header_right v-if="params.header_right">
            <div v-html="params.header_right"></div>
        </template>
        <template #body>
            <div class="container">
                <div class="row">
                    <help-card v-for="(item, i) in params.items" :key="i" v-bind="item"/>
                </div>
            </div>
        </template>
    </AppSection>
</template>

<script>
import AppSection from '../AppSection.vue'
import HelpCard from '../cards/HelpCard.vue'

export default {
    name: 'HelpSection',
    props: {
        params: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        AppSection,
        HelpCard,
    },
    setup: (props, ctx) => {

        return {

        }
    },
}
</script>

<style lang="scss">
    .section-help {
        &.bg {
            background: var(--c-gray-800);
            padding: 270px 0 90px 0;
            margin-top: -200px;

            @include tablet {
                padding: 220px 0 90px 0;
            }
            @include tablet {
                padding: 28px 0 40px 0;
                margin-top: 0;
            }
        }
    }
</style>
